import { getGalleryApi } from "../../api/home/galleryApi";
import {
  GET_GALLERY_SUCCESS,
  GET_GALLERY_FAILURE,
} from "../types";

export const getGallerySuccess = (homepage) => ({
  type: GET_GALLERY_SUCCESS,
  payload: homepage,
});

export const getGalleryFailure = (error) => ({
  type: GET_GALLERY_FAILURE,
  payload: error,
});

export const getGallery = (postData) => {
  return (dispatch) => {
    getGalleryApi(postData)
      .then((response) => {
        dispatch(getGallerySuccess(response.data));
      })
      .catch((error) => {
        dispatch(getGalleryFailure(error.message));
      });
  };
};
